"use strict";

angular.module("customer")
.component("inventoryQuantity", {
    bindings: {
        quantity: "=",
        catalogEntry: "=",
        vendor: "="
    },
    templateUrl: require("./inventory-quantity.component.html"),
    controller: function(
        $scope, StocksService, PatternService, ModalService, gettextCatalog, common, IS_MOBILE, IS_MOBILE_APP
    ) {
        var _this = this;
        var initialQuantity = this.quantity || 0;
        var newQuantity = initialQuantity;
        $scope.isTouchOptimized = IS_MOBILE || IS_MOBILE_APP;
        $scope.pattern = PatternService;

        this.getLengthClass = function() {
            return StocksService.getLengthClass(this.quantity);
        };

        this.getErrorClass = function() {
            return {
                'value-changed': initialQuantity !== this.quantity,
                'value-unchanged': initialQuantity === this.quantity
            }
        };

        this.changeQuantity = function() {
            var currentQuantity = this.quantity;

            ModalService.showModal({
                templateUrl: require("customer/app-core/inventory/modals/inventory-quantity.modal.html"),
                controller: "QuantityModalController",
                controllerAs: "quantityModalCtrl",
                inputs: {
                    $attrs: {
                        originalQuantity: currentQuantity,
                        packagingQuantity: this.catalogEntry.packaging_quantity
                    }
                }
            }).then(
                function onSuccess(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(
                        function onSuccess(quantity) {
                            modal.element.remove();
                            if (quantity >= 0 && quantity !== newQuantity) {
                                _this.saveQuantity(quantity);
                            }
                        }
                    );
                }
            );
        };

        this.saveQuantity = function(quantity) {
            StocksService.updateInventoryQuantity(this.catalogEntry, quantity, this.vendor)
            .then(function onSuccess(inventory_product) {
                _this.quantity = quantity;
                newQuantity = _this.quantity;
                angular.extend(_this.catalogEntry.product.inventory_product, inventory_product);
            });
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/inventory/inventory-quantity.component.js
// module id = 796
// module chunks = 0